export const getInitialBornPlaces = (grandparentsList: string[]) => {
  return grandparentsList.reduce((result, grandparent) => {
    return { ...result, [grandparent]: { city: '', country: '', dontKnow: false } };
  }, {});
};
